// extracted by mini-css-extract-plugin
export default {"form":"IntegrationGoogleModal_form__QUYlO","footer":"IntegrationGoogleModal_footer__uewwg","button":"IntegrationGoogleModal_button__8wwlI"};